import { ReasonCode } from "types/landlord/reports";
import {
  AdditionalBenefitsData,
  BenefitsStatementItem
} from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified/benefits-statement";

const getRejectionChecks = (additionalData: AdditionalBenefitsData) => {
  return [
    {
      condition: additionalData.type_mismatch === true,
      reasonCode: {
        code: "",
        confidence: "HIGH",
        description: "The document is not a benefits statement"
      }
    },
    {
      condition: additionalData.is_name_present === false,
      reasonCode: {
        code: "",
        confidence: "HIGH",
        description: "No name present on document"
      }
    },
    {
      condition: additionalData.low_trust_score === true,
      reasonCode: {
        code: "",
        confidence: "HIGH",
        description: "Low trust score"
      }
    },
    {
      condition: additionalData.low_quality_score === true,
      reasonCode: {
        code: "",
        confidence: "HIGH",
        description: "The file is of poor quality"
      }
    }
  ];
};

export const getBenefitsStatementReasonCodes = (
  benefitsStatement?: BenefitsStatementItem
) => {
  const warnings: ReasonCode[] = [];
  const additionalData = benefitsStatement?.income_source_data?.additional_data;
  if (!benefitsStatement || !additionalData) return warnings;

  const checks = getRejectionChecks(additionalData);
  checks.forEach(({ condition, reasonCode }) => {
    if (condition) warnings.push(reasonCode);
  });

  return warnings;
};
